var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wp-items-view',{attrs:{"content-type":"pages","content-type-singular":"page","content-name":"Pages","content-name-singular":"Page"}})}
var staticRenderFns = []

export { render, staticRenderFns }